import React from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { Image } from 'widgets/Image'

interface TransparentOverlayProps {
  children: React.ReactNode | string
  source: { uri?: string }
}

const styles = StyleSheet.create({
  box: {
    position: 'absolute',
    padding: 0,
    margin: 0,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  image: {
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
})

export const TransparentOverlay = ({ children, source }: TransparentOverlayProps) => (
  <Box style={styles.box}>
    <Image cacheKey='transparentOverlay' style={styles.image} source={source} />
    {children}
  </Box>
)
